export default __webpack_public_path__ + "static/media/mobile-banner.061c0bec.png";